import React, { createContext, useMemo, useState } from 'react'

export const HeaderInViewContext = createContext<{
  inView: boolean
  setInView:(value: boolean) => void
    }>({
      inView: true,
      setInView: (_value: boolean) => {},
    })

function HeaderInViewContextProvider({ children }: React.PropsWithChildren) {
  const [value, setValue] = useState<boolean>(true)

  const contextValue = useMemo(() => {
    return {
      inView: value,
      setInView: (value: boolean) => setValue(value),
    }
  }, [value])

  return (
    <HeaderInViewContext.Provider value={contextValue}>
      {children}
    </HeaderInViewContext.Provider>
  )
}
export default HeaderInViewContextProvider
